import { render, staticRenderFns } from "./serviceComissions.vue?vue&type=template&id=2f6dd4f8&scoped=true&"
import script from "./serviceComissions.vue?vue&type=script&lang=js&"
export * from "./serviceComissions.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=2f6dd4f8&scoped=true&lang=css&"
import style1 from "./serviceComissions.vue?vue&type=style&index=1&id=2f6dd4f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6dd4f8",
  null
  
)

export default component.exports